module.exports = __webpack_public_path__ + "img/샐러맨더 (2).f578b302.png";